import React from 'react'

export const BabyIcon = (props) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.0832 9.79183C12.6585 9.79183 13.1248 9.32546 13.1248 8.75016C13.1248 8.17487 12.6585 7.7085 12.0832 7.7085C11.5079 7.7085 11.0415 8.17487 11.0415 8.75016C11.0415 9.32546 11.5079 9.79183 12.0832 9.79183Z"
      fill="currentColor"
    />
    <path
      d="M7.91667 9.79183C8.49196 9.79183 8.95833 9.32546 8.95833 8.75016C8.95833 8.17487 8.49196 7.7085 7.91667 7.7085C7.34137 7.7085 6.875 8.17487 6.875 8.75016C6.875 9.32546 7.34137 9.79183 7.91667 9.79183Z"
      fill="currentColor"
    />
    <path
      d="M19.1168 10.55C19.1502 10.375 19.1668 10.1917 19.1668 10C19.1668 9.80833 19.1502 9.625 19.1168 9.45C18.9085 8.19167 17.9835 7.16667 16.7752 6.80833C16.3335 5.875 15.7085 5.05833 14.9502 4.38333C13.6335 3.20833 11.9002 2.5 10.0002 2.5C8.10016 2.5 6.36683 3.20833 5.05016 4.38333C4.2835 5.05833 3.6585 5.88333 3.22516 6.80833C2.01683 7.16667 1.09183 8.18333 0.883496 9.45C0.850163 9.625 0.833496 9.80833 0.833496 10C0.833496 10.1917 0.850163 10.375 0.883496 10.55C1.09183 11.8083 2.01683 12.8333 3.22516 13.1917C3.6585 14.1167 4.2835 14.9333 5.0335 15.6C6.35016 16.7833 8.09183 17.5 10.0002 17.5C11.9085 17.5 13.6502 16.7833 14.9752 15.6C15.7252 14.9333 16.3502 14.1083 16.7835 13.1917C17.9835 12.8333 18.9085 11.8167 19.1168 10.55ZM15.8335 11.6667C15.7502 11.6667 15.6752 11.65 15.5918 11.6417C15.4252 12.2 15.1835 12.7167 14.8752 13.1917C13.8335 14.7833 12.0418 15.8333 10.0002 15.8333C7.9585 15.8333 6.16683 14.7833 5.12516 13.1917C4.81683 12.7167 4.57516 12.2 4.4085 11.6417C4.32516 11.65 4.25016 11.6667 4.16683 11.6667C3.25016 11.6667 2.50016 10.9167 2.50016 10C2.50016 9.08333 3.25016 8.33333 4.16683 8.33333C4.25016 8.33333 4.32516 8.35 4.4085 8.35833C4.57516 7.8 4.81683 7.28333 5.12516 6.80833C6.16683 5.21667 7.9585 4.16667 10.0002 4.16667C12.0418 4.16667 13.8335 5.21667 14.8752 6.80833C15.1835 7.28333 15.4252 7.8 15.5918 8.35833C15.6752 8.35 15.7502 8.33333 15.8335 8.33333C16.7502 8.33333 17.5002 9.08333 17.5002 10C17.5002 10.9167 16.7502 11.6667 15.8335 11.6667ZM6.25016 11.6667C6.8835 13.1417 8.32516 14.1667 10.0002 14.1667C11.6752 14.1667 13.1168 13.1417 13.7502 11.6667H6.25016Z"
      fill="currentColor"
    />
  </svg>
)

export const CalendarIcon = (props) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.1667 10.0002H10V14.1668H14.1667V10.0002ZM13.3333 0.833496V2.50016H6.66667V0.833496H5V2.50016H4.16667C3.24167 2.50016 2.50833 3.25016 2.50833 4.16683L2.5 15.8335C2.5 16.7502 3.24167 17.5002 4.16667 17.5002H15.8333C16.75 17.5002 17.5 16.7502 17.5 15.8335V4.16683C17.5 3.25016 16.75 2.50016 15.8333 2.50016H15V0.833496H13.3333ZM15.8333 15.8335H4.16667V6.66683H15.8333V15.8335Z"
      fill="currentColor"
    />
  </svg>
)

export const ClockIcon = (props) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.99175 1.6665C5.39175 1.6665 1.66675 5.39984 1.66675 9.99984C1.66675 14.5998 5.39175 18.3332 9.99175 18.3332C14.6001 18.3332 18.3334 14.5998 18.3334 9.99984C18.3334 5.39984 14.6001 1.6665 9.99175 1.6665ZM10.0001 16.6665C6.31675 16.6665 3.33341 13.6832 3.33341 9.99984C3.33341 6.3165 6.31675 3.33317 10.0001 3.33317C13.6834 3.33317 16.6667 6.3165 16.6667 9.99984C16.6667 13.6832 13.6834 16.6665 10.0001 16.6665Z"
      fill="currentColor"
    />
    <path
      d="M10.4167 5.8335H9.16675V10.8335L13.5417 13.4585L14.1667 12.4335L10.4167 10.2085V5.8335Z"
      fill="currentColor"
    />
  </svg>
)

export const TentIcon = (props) => (
  <svg
    viewBox="0 -960 960 960"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M80-80v-183l363-491-67-90 49-35 55 75 56-75 48 35-66 90 362 491v183H80Zm400-623L140-243v103h145l195-273 195 273h145v-103L480-703ZM359-140h242L480-310 359-140Zm121-273 195 273-195-273-195 273 195-273Z"
      fill="currentColor"
    />
  </svg>
)

//Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) Copyright 2023 Fonticons, Inc.
export const PawIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <path
      fill="currentColor"
      d="M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 480 64 459.1 64 433.3v-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5z"
    />
  </svg>
)

export const HeartIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <path
      fill="currentColor"
      d="M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"
    />
  </svg>
)

export const TicketIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" {...props}>
    <path
      fill="currentColor"
      d="M64 64C28.7 64 0 92.7 0 128v64c0 8.8 7.4 15.7 15.7 18.6C34.5 217.1 48 235 48 256s-13.5 38.9-32.3 45.4C7.4 304.3 0 311.2 0 320v64c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V320c0-8.8-7.4-15.7-15.7-18.6C541.5 294.9 528 277 528 256s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6V128c0-35.3-28.7-64-64-64H64zm64 112l0 160c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM96 160c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160z"
    />
  </svg>
)
export const CardIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" {...props}>
    <path
      fill="currentColor"
      d="M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
    />
  </svg>
)

export const LogoutIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" {...props}>
    <defs>
      <clipPath id="clip-ozf-nav-logout">
        <rect width="35" height="35" />
      </clipPath>
    </defs>
    <g id="ozf-nav-logout" clipPath="url(#clip-ozf-nav-logout)">
      <path
        id="noun-logout-3686971"
        d="M90.392,52.5A2.907,2.907,0,0,0,87.5,55.391V74.668a2.907,2.907,0,0,0,2.892,2.892H98.1a2.907,2.907,0,0,0,2.892-2.892V71.778H96.178a4.866,4.866,0,0,1-4.821-4.82V63.1a4.866,4.866,0,0,1,4.821-4.821h4.817v-2.89A2.907,2.907,0,0,0,98.1,52.5Zm15.551,3.856a2.907,2.907,0,0,0-3.02,2.889v.964H96.178A2.908,2.908,0,0,0,93.286,63.1v3.856a2.908,2.908,0,0,0,2.893,2.893h6.745v.964a2.925,2.925,0,0,0,4.625,2.313l7.713-5.781a2.916,2.916,0,0,0,0-4.628l-7.713-5.786a2.889,2.889,0,0,0-1.605-.576Z"
        transform="translate(-84.451 -47.53)"
        fill="currentColor"
      />
    </g>
  </svg>
)
